import { render, staticRenderFns } from "./MbQuiz.vue?vue&type=template&id=37edac60&scoped=true&"
import script from "./MbQuiz.vue?vue&type=script&lang=js&"
export * from "./MbQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MbQuiz.vue?vue&type=style&index=0&id=37edac60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edac60",
  null
  
)

export default component.exports